import { dateOrDateTimeFormatter, dateTimeFormatter, vehicleRegistrationPlateFormatter } from '../../utils/formatters';

const detectBlackWhiteLpnType = lpn => {
  const normalized = String(lpn || '').replace(/[\s-]+/g, '').toUpperCase();
  const ruLetters = 'ABEKMHOPCTYXАВЕКМНОРСТУХ';

  if (/^\d{2}[A-Z]{2}\d{3}$/.test(normalized)) {
    return 'az';
  }

  if (new RegExp(`^[${ruLetters}]\\d{4}\\d{2,3}$`).test(normalized)) {
    return 'ru_blue';
  }

  if (new RegExp(`^(?:\\d{4}[${ruLetters}]{2}|[${ruLetters}]{2}\\d{4})\\d{2,3}$`).test(normalized)) {
    return 'ru_black';
  }

  if (/^(?:[CD]{2}\d{3}|\d{3}(?:CD\d|[DT]\d{3}))\d{2,3}$/.test(normalized)) {
    return 'ru_red';
  }

  if (new RegExp(`^[${ruLetters}]{2}\\d{3}\\d{2,3}$`).test(normalized)) {
    return 'ru_yellow';
  }

  if (new RegExp(`^[${ruLetters}]\\d{3}[${ruLetters}]{2}\\d{2,3}$`).test(normalized)) {
    return 'ru';
  }

  return null;
};

const subscriptionIntervalFormatter = interval => {
  const start = dateTimeFormatter(interval?.start_at);
  const end = dateTimeFormatter(interval?.end_at);

  return [start, end].filter(Boolean).join(' - ');
};

export const subscriptionColumns = [
  {
    dataField: 'id',
    text: 'ИД',
    disableSort: true,
    dataClassName: 'align-middle',
    hidden: true,
  },
  {
    dataField: 'lpns',
    text: 'ГРЗ',
    disableSort: true,
    formatter: lpns => (lpns || []).join(', '),
    dataClassName: 'align-middle',
  },
  {
    dataField: 'is_lpn_exact',
    text: 'Строгая проверка ГРЗ',
    formatter: e => (e ? 'Да' : 'Нет'),
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'card_uid',
    text: 'ИД карты',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'is_vip',
    text: 'VIP',
    formatter: e => (e ? 'Да' : 'Нет'),
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'comment',
    text: 'Комментарий',
    disableSort: true,
    dataClassName: 'align-middle',
    hidden: true,
  },
  {
    dataField: 'subscription_intervals',
    text: 'Интервалы',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: e => (e || []).map(subscriptionIntervalFormatter).filter(Boolean).join(', '),
    hidden: true,
  },
];

export const subscriptionPresetColumns = [
  {
    dataField: 'id',
    text: 'ИД',
    disableSort: true,
    dataClassName: 'align-middle',
    hidden: true,
  },
  {
    dataField: 'name',
    text: 'Название',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'duration',
    text: 'Длительность',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'price',
    text: 'Стоимость',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'priority',
    text: 'Сортировка',
    disableSort: true,
    dataClassName: 'align-middle',
  },
  {
    dataField: 'created_at',
    text: 'Создан',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateOrDateTimeFormatter(a),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
  },
  {
    dataField: 'updated_at',
    text: 'Изменен',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateOrDateTimeFormatter(a),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
  },
];

export const blackWhitesColumns = [
  {
    dataField: 'lpn',
    text: 'ГРЗ',
    disableSort: true,
    formatter: (_, item) => {
      const lpnType = item?.lpn_type || detectBlackWhiteLpnType(item?.lpn);

      if (!lpnType) {
        return item?.lpn || '';
      }

      return vehicleRegistrationPlateFormatter({
        lpn: item?.lpn,
        lpn_type: lpnType,
      });
    },
    headerClassName: 'lpn-column',
    dataClassName: 'align-middle',
  },
  {
    dataField: 'created_at',
    text: 'Создан',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateOrDateTimeFormatter(a),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
  },
  {
    dataField: 'updated_at',
    text: 'Изменен',
    disableSort: true,
    dataClassName: 'align-middle',
    formatter: a => dateOrDateTimeFormatter(a),
    toCopyFormatter: dateTimeFormatter,
    headerClassName: 'date-time-column',
    hidden: true,
  },
];
